import React from "react";
import Loader from "storybookComponents/Loader";
import MobilePreview from "storybookComponents/MobilePreview";
import { smsPreviewHtml, linkify } from "../../utils/index"
import SwipeableViews from "react-swipeable-views";

import "./style.css";

export default (props) => {

  console.log("props_ ", props)

  const [loading, setLoading] = React.useState(false);
  const [subject, setSubject] = React.useState(props.subject);

  React.useEffect(() => {
    const frame = document.getElementById("Iframe");
    if (!frame) return
    frame.onload = () => {
      frame.style.height =
        (frame.contentWindow.document.body.scrollHeight + 40) + 'px';
      frame.style.width = frame.contentWindow.document.body.scrollWidth + 'px';
      setTimeout(() => {
        setLoading(false)
      }, 1000)
    }
  })

  const handleChangeInput = (e) => {
    setSubject(e.target.value)
  }

  const smsHtml = smsPreviewHtml(props.smsImage, props.smsContent, props.orgColors.linkColor, false)
  return (
    <>
      {
        !props.mobileView && !props.smsView ?
          <div id="email-preview-container">
            {
              loading ? <Loader /> : null
            }
            <div className="subject">
              <label>Subject</label>

              <input value={subject} disabled onChange={handleChangeInput} />

            </div>
            <iframe id="Iframe" srcDoc={props.html} style={{ width: "100%", minHeight: '1200px', border: "none" }} />
          </div>
          :
          <SwipeableViews index={props.smsView ? 0 : 1} animateTransitions={false}>
            <div style={{ width: "max-content", margin: "auto" }}>
              <MobilePreview id="p7" smsView html={smsHtml} />
            </div>

            <div style={{ width: "max-content", margin: "auto" }}>
              <MobilePreview id="p8" html={props.html} />
            </div>
          </SwipeableViews>
      }


    </>
  )
}